import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'modules/react/components/stateless/Icon';
import { EN_US } from 'shared/i18n';
import { TRACK_SEARCH_NEARBY_LOCATIONS } from 'utils/dataLayer';
import ThemedButton from '../../../../website/components/stateless/ThemedButton';
import Translation from '../../../../website/components/stateless/Translation';
import { pushRoute } from '../../../../modules/routing';
import style from './SMSearchNearby.scss';

const propTypes = {
  isPreview: PropTypes.bool,
  locale: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  pageType: PropTypes.string,
};

const defaultProps = {};

const SMSearchNearby = ({ locale, pathname }) => {
  const handleSearch = () => {
    const isUS = locale === EN_US;
    const intlPrefix = pathname === `${locale}/search` ? 'search' : `/${locale}/search`;
    const route = `${isUS ? '/search' : `${intlPrefix}`}?userLocation=true`;

    pushRoute(route);
  };

  return (
    <div className={style.container}>
      <ThemedButton
        className={style.nearbyLocationBtn}
        onClick={handleSearch}
        {...TRACK_SEARCH_NEARBY_LOCATIONS}
      >
        <Translation id="widgets.searchGeo.searchNearbyLocations" defaultMessage="Search Nearby Locations" />
        <span className={style.icon}>
          <Icon id="locations-pin" label="search nearby facilities" />
        </span>
      </ThemedButton>
    </div>
  );
};

SMSearchNearby.propTypes = propTypes;
SMSearchNearby.defaultProps = defaultProps;

export default SMSearchNearby;
